import { render, staticRenderFns } from "./PeriodDuration.vue?vue&type=template&id=3c50cc04&scoped=true&"
import script from "./PeriodDuration.vue?vue&type=script&lang=js&"
export * from "./PeriodDuration.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDuration.vue?vue&type=style&index=0&id=3c50cc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50cc04",
  null
  
)

export default component.exports